import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	edit: {},
	isLoaded: true,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR SECTION STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// ****************** FETCH SECTION ******************
			case types.FETCH_SECTIONS_GROUP_LOADING:
				draft.isLoaded = false;
				return;

			case types.FETCH_SECTIONS_GROUP_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				return;

			case types.FETCH_SECTIONS_GROUP_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
